import { Component, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-salva-flusso',
  templateUrl: './salva-flusso.component.html',
  styleUrls: ['./salva-flusso.component.css']
})
export class SalvaFlussoComponent implements OnInit {
	@Input() flowEnv: any = {
		id: '',
		nome: '',
		descrizione: '',
		creazione: '',
		aggiornamento: '',
		attivo: '',
		contenuto: {
			stateSettings: {},
			customStates: [],
			defaultStates: [],
			workflow: {
				states: [],
				connections: {}
			}
		}
	};
	@Input() writePermission: boolean = false;

	@Output() innerEvents = new EventEmitter();

	constructor() {}

	ngOnInit() {}

	ngOnChanges(changes:any) {
		console.log('CMP|SALVA-FLUSSO - CHANGES', changes);
	}

	hide(){
		let event:any = {
			hide: true
		}
		this.innerEvents.emit(event);
	}

	discard() {
		this.hide();
	}

	saveNew() {
		let event:any = {
			hide: true,
			flowEvent: true,
			data: {
				type: 'saveNew',
				content: this.flowEnv
			}
		}
		this.innerEvents.emit(event);
	}

	update() {
		let event:any = {
			hide: true,
			flowEvent: true,
			data: {
				type: 'updateFlow',
				content: this.flowEnv
			}
		}
		this.innerEvents.emit(event);
	}

	checkFields(update) {
		let check:boolean = true;
		if (this.flowEnv.nome && this.flowEnv.descrizione) {
			check = false;
		}
		if (update) {
			if (!this.flowEnv.id) {
				check = true;
			}
		}
		return check;
	}

	isDefaultFlow() {
		return this.flowEnv.comune_id == null;
	}
}
